import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, ShoppingBag } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from './contexts/LanguageContext';
import { t } from './translations';

const OrderSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-surface flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="max-w-md w-full bg-card rounded-3xl shadow-xl p-8 text-center"
      >
        <div className="w-20 h-20 bg-success-bg-50 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-10 h-10 text-success-fg" />
        </div>
        <h1 className="text-2xl font-black text-ink mb-2 uppercase tracking-tight">
          {t('checkout.isPaid', language)}
        </h1>
        <p className="text-ink-soft mb-8 font-medium">
          {t('checkout.paymentSuccess', language)}
        </p>
        <button
          onClick={() => navigate('/')}
          className="w-full bg-[var(--btn-dark-bg)] text-white py-4 rounded-2xl font-black uppercase tracking-widest flex items-center justify-center gap-2 hover:bg-[var(--btn-dark-bg-hover)] transition-colors"
        >
          <ShoppingBag className="w-5 h-5" />
          {t('checkout.backToMenu', language)}
        </button>
      </motion.div>
    </div>
  );
};

export default OrderSuccess;
